export default "__VITE_ASSET__25f5dd22__"